import { render, staticRenderFns } from "./AttachMailToNewAccountQuote.vue?vue&type=template&id=8f92b1e2&scoped=true&"
import script from "./AttachMailToNewAccountQuote.vue?vue&type=script&lang=js&"
export * from "./AttachMailToNewAccountQuote.vue?vue&type=script&lang=js&"
import style0 from "./AttachMailToNewAccountQuote.vue?vue&type=style&index=0&id=8f92b1e2&prod&scoped=true&lang=css&"
import style1 from "./AttachMailToNewAccountQuote.vue?vue&type=style&index=1&id=8f92b1e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f92b1e2",
  null
  
)

export default component.exports